const loginPage = '';
export const PATHS_LOGIN_PAGES = {
    loginPage: {
        withSlash: `/${loginPage}`,
        onlyPath: loginPage
    }
};

const changePasswordPage = 'changePassword';
export const PATHS_CHANGE_PASSWORD_PAGES = {
    changePasswordPage: {
        withSlash: `/${changePasswordPage}`,
        onlyPath: changePasswordPage
    }
};

const homePage = 'home';
export const PATH_HOME_PAGES = {
    homePage: {
        withSlash: `/${homePage}`,
        onlyPath: homePage
    }
};


const userPage = 'user'
const newUserPage = 'newUser'
const listUserPage = 'listUser'
const updateUserPage = 'updateUser'
export const PATHS_USER_PAGES = {
    withSlash: `/${userPage}`,
    onlyPath: userPage,

    newUserPage: {
        withSlash: `/${userPage}/${newUserPage}`,
        onlyPath: newUserPage
    },

    listUserPages: {
        withSlash: `/${userPage}/${listUserPage}`,
        onlyPath: listUserPage
    },

    updateUserPages: {
        withSlash: `/${userPage}/${updateUserPage}`,
        onlyPath: updateUserPage
    }
}

const profilePage = 'profile'
const newProfilePage = 'newProfile'
const listProfilePage = 'listProfile'
const updateProfilePage = 'updateProfile'
export const PATHS_PROFILE_PAGES = {
    withSlash: `/${profilePage}`,
    onlyPath: profilePage,

    newProfilePage: {
        withSlash: `/${profilePage}/${newProfilePage}`,
        onlyPath: newProfilePage
    },

    listProfilePages: {
        withSlash: `/${profilePage}/${listProfilePage}`,
        onlyPath: listProfilePage
    },

    updateProfilePages: {
        withSlash: `/${profilePage}/${updateProfilePage}`,
        onlyPath: updateProfilePage
    }
}


